export const KAKAO_CHAT = process.env.REACT_APP_KAKAO_URL;
